import React from 'react';
import IndexPage from './index';

const IndexPageEn = () => {
  return <IndexPage lang="en"></IndexPage>;
};

export default IndexPageEn;
